import { render } from "./BOverlay.vue?vue&type=template&id=1985285d"
import script from "./BOverlay.vue?vue&type=script&lang=js"
export * from "./BOverlay.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__